<template>
  <div class="l-main">
    <div class="l-main__header">
      <ul class="c-breadcrumbs">
        <li class="c-breadcrumbs__item">
          <a
            class="c-breadcrumbs__link c-breadcrumbs__home c-breadcrumbs__home--disabled"
            @click="goToHome"
          >
            <md-icon>home</md-icon>
            <span>Home</span>
          </a>
        </li>
        <li class="c-breadcrumbs__item--separator">
          /
        </li>
        <li class="c-breadcrumbs__item is-current">
          <a class="c-breadcrumbs__link">Configurations</a>
        </li>
      </ul>
    </div>
    <div class="l-main__ctn u-box c-config">
      <app-tabs
        v-if="selectedTab.tab"
        :tabs="navigationTabs"
        :value="selectedTab.tab"
        label="Configuration sections"
        @input="changeActiveTab"
      />
      <div class="c-config__panel">
        <component
          :is="selectedTab.component"
          v-if="selectedTab.component"
          :key="selectedTab.tab"
          :tab="selectedTab.tab"
        />
      </div>
    </div>
  </div>
</template>

<script>

import OnlineCustomPagesList from './components/custom-pages';
import OnlineCasinoCategoriesList from './components/casino-categories';
import OnlineTooltipsSportList from './components/tooltips';
import {PERMISSION_NAMES} from "@/const/online-permissions";
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";
import HelpLinkList from '../help/sub-pages/help-links';
import BigJackpotConfiguration from './components/big-jackpot';
import ImgArenaConfiguration from './components/img-arena';
import OnlineIconsList from './components/icons';
import GeneralConfiguration from './components/general';
import AppTabs from '@/shared/app-tabs/AppTabs';

export default {
  name: 'OnlineConfigurations',
  components: {
    OnlineCustomPagesList,
    OnlineCasinoCategoriesList,
    OnlineTooltipsSportList,
    OnlineIconsList,
    HelpLinkList,
    BigJackpotConfiguration,
    ImgArenaConfiguration,
    GeneralConfiguration,
    AppTabs,
  },

  mixins: [onlinePermissionsMixin],

  data() {
    return {
      selectedTab: {
        tab: 'img-arena',
        label: 'Img Arena',
        component: 'ImgArenaConfiguration',
      },
      configurationTabs: [
        {
          tab: 'general',
          icon: 'tune',
          label: 'General',
          onlyDevelopers: false,
          permission: `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.GENERAL.key}`,
          component: 'GeneralConfiguration',
        },
        {
          tab: 'img-arena',
          icon: 'live_tv',
          label: 'Img Arena',
          component: 'ImgArenaConfiguration',
          permission: `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.IMG_ARENA.key}`,
          onlyDevelopers: false,
        },
        {
          tab: 'custom-pages',
          icon: 'description',
          label: 'Custom Pages',
          component: 'OnlineCustomPagesList',
          onlyDevelopers: true,
        },
        {
          tab: 'casino-categories',
          icon: 'casino',
          label: 'Casino Categories',
          component: 'OnlineCasinoCategoriesList',
          onlyDevelopers: true,
        },
        {
          tab: 'tooltips',
          icon: 'info',
          label: 'Tooltips',
          component: 'OnlineTooltipsSportList',
          permission: `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.TOOLTIPS.key}`
        },
        {
          tab: 'help-links',
          icon: 'link',
          label: 'Help Links',
          component: 'HelpLinkList',
          onlyDevelopers: true,
        },
        {
          tab: 'big-jackpot',
          icon: 'savings',
          label: 'Big Jackpot',
          component: 'BigJackpotConfiguration',
          permission: `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.BIG_JACKPOT.key}`,
          onlyDevelopers: false,
        },
        {
          tab: 'icons',
          icon: 'interests',
          label: 'Icons',
          onlyDevelopers: false,
          permission: `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.ICONS.key}`,
          component: 'OnlineIconsList',
        },
      ],
    };
  },

  computed: {
    navigationTabs() {
      return this.configurationTabs.map(({ tab, label, icon }) => ({ key: tab, label, icon }));
    },
  },

  created() {
    if (this.user.isDeveloper) {
      return;
    }

    this.configurationTabs = this.configurationTabs.filter(tab => {
      if (tab.onlyDevelopers) {
        return false;
      }

      return this.canRead(tab.permission)
    });

    this.selectedTab = this.configurationTabs[0];
  },

  methods: {
    changeActiveTab(tabKey) {
      this.selectedTab = this.configurationTabs.find(tab => tab.tab === tabKey);
    },

    goToHome() {
      this.$router.push({name: 'home'});
    },
  },
};
</script>

<style lang="scss" scoped>
.c-config {
  overflow: hidden;
}

// only the selected section scrolls; the tab bar stays put
.c-config__panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 20px 24px 24px;
  overflow-y: auto;
  scrollbar-gutter: stable;

  // sections still wrap themselves in page layouts (l-main / l-main__ctn);
  // flatten them so the panel is the only scroll area
  ::v-deep .l-main,
  ::v-deep .l-main__ctn {
    flex: 1 1 auto;
    min-width: 0;
    height: auto;
    min-height: auto;
    overflow: visible;
  }
}
</style>
